// extracted by mini-css-extract-plugin
export default {"container":"_2Xele","row":"wQjuV","column":"_1F5ZK","iconColumn":"_1nx1g"};